import { HttpContext, HttpContextToken } from "@angular/common/http";

/**
 * Marca una petición como de FONDO: la lanza la pantalla sola, no el
 * usuario.
 *
 * Nace del tablero de Solicitudes de IA, que se refresca cada pocos
 * segundos en vez de tener un botón de Actualizar. Una petición así no
 * es como las demás y hay TRES cosas que no debe hacer:
 *
 *   1. Sacar el velo de "Cargando…" a pantalla completa. Está bien
 *      cuando alguien acaba de pulsar algo y espera; una pantalla que se
 *      refresca sola haría parpadear la aplicación entera sin que nadie
 *      hubiera pedido nada.
 *
 *   2. Reiniciar el reloj de inactividad. Ese reloj es el que cierra la
 *      sesión de quien se levanta de su sitio. Un refresco automático lo
 *      pondría a cero cada medio minuto y la sesión ya NUNCA caducaría,
 *      que es justo lo contrario de lo que se busca.
 *
 *   3. Cerrar la sesión y recargar la página ante un 401. Le arrancaría
 *      la pantalla de las manos a quien estuviera escribiendo. El error
 *      llega al componente, que apaga su refresco; la siguiente cosa que
 *      el usuario haga de verdad sí lo mandará al login.
 *
 * Va por HttpContext y no por una cabecera a propósito: el contexto se
 * queda del lado del navegador y nunca viaja al servidor. El token
 * arranca en `false`, así que TODA petición que no lo pida explícitamente
 * se comporta exactamente igual que siempre.
 *
 * Uso:
 *
 *   this.http.post(url, req, { context: deFondo() })
 */
export const EN_SEGUNDO_PLANO = new HttpContextToken<boolean>(() => false);

/** Azúcar, para no repetir el `new HttpContext().set(...)` en cada llamada. */
export function deFondo(): HttpContext {
  return new HttpContext().set(EN_SEGUNDO_PLANO, true);
}
